import { useEffect, useState } from "react";
import { Tooltip, Iconfont } from "@eweadn-qiankun/shared-components";
import { useTranslation } from "react-i18next";
import { useSdkApi } from "../../stores/sdkStore";
import { getElementXyData } from "./hooks/useAdvancedKeyState";
const end = (props: any) => {
  const { checkData, getAfterChangeData, getElementXy } = props;
  const wizardSteps = checkData?.wizard?.steps ?? [];
  const { t } = useTranslation();
  const [currentKeyRef, setCurrentKeyRef] = useState<any>(null); // 存储当前选中的元素引用

  const globalSdkApi = useSdkApi();
  const sdkApi = globalSdkApi?.keyboard;
  const { sdkKeyboardBasicApi } = sdkApi || {};
  const getCurrentEquipmentData = sdkKeyboardBasicApi?.getCurrentEquipmentData;
  const solutionRovider = getCurrentEquipmentData?.()?.solutionRovider;

  const setKeyCheck = (key: number, e: any) => {
    const newCheckData = JSON.parse(JSON.stringify(checkData));
    newCheckData.triggerData.map((items: any, keys: number) => {
      if (key === keys) {
        items.check = true;
      } else {
        items.check = false;
      }
      return items;
    });
    getAfterChangeData(newCheckData);
    setCurrentKeyRef(e.currentTarget); // 存储当前元素引用
    getElementXy(getElementXyData(e));
  };

  const showPressKeySelectHint = (index: number) => {
    if (checkData?.triggerData[index]?.label) return false;
    for (let i = 0; i < index; i++) {
      if (!checkData?.triggerData[i]?.label) return false;
    }
    return true;
  };
  const isPickerOpen = checkData?.triggerData?.some((t: any) => t.check);

  // 监听浏览器缩放（resize 事件）
  useEffect(() => {
    const handleResize = () => {
      if (currentKeyRef) {
        // 缩放时重新计算坐标
        getElementXy(getElementXyData({ target: currentKeyRef }), false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [currentKeyRef, getElementXy]); // 依赖当前元素引用

  return (
    <div className="advance-setting-box">
      <div className="advance-setting-box-header">
        <div className="advance-setting-box-header-title">
          {wizardSteps[1]?.titleKey ? t(wizardSteps[1].titleKey) : ""}
        </div>
        <div className="advance-setting-box-header-desc">
          {wizardSteps[1]?.descKey ? t(wizardSteps[1].descKey) : ""}
        </div>
      </div>
      <div className="operation-item operation-end">
        <div className="end-mode-box">
          <div className="select-presskey-box">
            {(solutionRovider === "beiying"
              ? checkData?.triggerData.slice(0, 1)
              : checkData?.triggerData
            ).map((item: any, key: number) => {
              const hintVisible = showPressKeySelectHint(key);
              const isClick = !item.label && item.check;
              return (
                <div
                  key={key}
                  className="base-pressKey"
                  onClick={(e: any) => setKeyCheck(key, e)}
                >
                  <Tooltip
                    text={
                      <div className="pressKey-tooltip">
                        <Iconfont
                          icon="warning"
                          className="pressKey-tooltip-icon"
                        />
                        <span>
                          {t(
                            "keyboard.advancedKey.baseModesText.selectKeyTips2"
                          )}
                        </span>
                      </div>
                    }
                    trigger="always"
                    placement="top"
                    usePortal
                    open={!isPickerOpen && hintVisible}
                    overlayProps={{
                      role: "status",
                      "aria-live": "polite",
                    }}
                  >
                    <div
                      className={`pressKey ${isClick ? "no-select" : ""} ${item.label ? "isActive" : ""}`}
                    >
                      {item.label ? (
                        <span>{item.label}</span>
                      ) : (
                        <Iconfont icon="plus" className="add-icon" />
                      )}
                    </div>
                  </Tooltip>
                  <div className="pressKey-desc">
                    {item.label
                      ? t(
                          `keyboard.advancedKey.endModes.selectedTriggerKey${key + 1}`
                        )
                      : t(`keyboard.advancedKey.endModes.triggerKey${key + 1}`)}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
export default end;
